
interface Tree {
  task_name: string;
  task_id: number;
  task_list?: Tree[];
  parameter_no?: number;
}
import Api from "@/api/userService";
import { DownOutlined } from "@ant-design/icons-vue";
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watch,
  onUnmounted,
} from "vue";
import {
  car_status_automaticsupplying,
  car_status_tosupply,
  car_status_stop,
  car_status_supplying,
} from "@/constant/DataTypeOptions";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";

export default defineComponent({
  props: {
    vin: {
      type: String,
      required: true,
      defualt: "",
    },
  },
  setup(props, context) {
    const { t } = useI18n();

    const settingShow = ref(false);
    const checkId = ref();
    const list = ref();
    const carVin = computed<string>(() => props.vin);
    const detail = ref<any>([]);
    const defaultProps = {
      children: "task_list",
      title: "task_name",
      key: "task_name",
    };
    const selectedKeys = ref();
    const store = useStore();
    const carStatuses = [
      car_status_automaticsupplying,
      car_status_tosupply,
      car_status_stop,
      car_status_supplying,
    ];
    const carStatus = computed(() => store.getters.getCarStatus);
    const isShow = ref(false);
    const handleVisible2 = (visible: any) => {
      if (checkId.value) {
        settingShow.value = true;
      }
      if (!visible) {
        settingShow.value = visible;
      }
    };
    const getCleanModeDetail = () => {
      Api.getCleanModeDetail(carVin.value).then((res: any) => {
        detail.value = res.result;
        isShow.value =
          !carStatuses.includes(store.getters.getCarStatus) &&
          detail.value?.clean_parameter_list?.length > 0;
      });
    };

    const handleNodeClick = (selectedKeys: any, info: any) => {
      checkId.value = info.node.parameter_no;
      detail.value.clean_parameter_list.map((item: any) => {
        if (info.node.parameter_no === item.clean_parameter_no) {
          list.value = item.clean_parameter;
        }
      });
      if (info.node.parameter_no) {
        settingShow.value = true;
      }
    };
    watch(carStatus, () => {
      getCleanModeDetail();
    });
    onMounted(() => {
      getCleanModeDetail();
    });
    onUnmounted(() => {
      store.commit("carStatus", "");
    });
    return {
      settingShow,
      handleVisible2,
      handleNodeClick,
      defaultProps,
      detail,
      list,
      isShow,
      selectedKeys,
      checkId,
      t,
    };
  },
});
